var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 2.26L5.3 4.51C4.52 4.81 4 5.55 4 6.39V11.09C4 11.4 4.01 11.7 4.04 12C4.4 16.49 7.41 20.55 11.44 21.84C11.81 21.96 12.21 21.96 12.57 21.84C16.6 20.55 19.6 16.49 19.97 12C19.99 11.7 20.01 11.4 20.01 11.09V6.39C20.01 5.56 19.49 4.81 18.71 4.52L12.71 2.27C12.25 2.09 11.75 2.09 11.3 2.26ZM12 19.92V12H6.05C6.02 11.7 6 11.4 6 11.09V6.39L12 4.14V12H17.95C17.6 15.64 15.19 18.88 12 19.92Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.c09fc211d6ef47d6e56d949da502df8d.svg";
export { ForwardRef as ReactComponent };